import { Shipment } from "@domain/shipment";
import { format } from "date-fns";
import { TransportMethodIcon } from "@features/shipments/components/shared/TransportMethodIcon";
import { Stack, Box, Typography, useTheme, Badge } from "@mui/material";
import { PurchaseOrder, PurchaseOrderItem } from "@domain/purchasing";
import { differenceInDays } from "date-fns";

interface PurchaseOrderItemPreviewProps {
    purchaseOrderItem: PurchaseOrderItem;
    onClick?: () => void;
}

const PurchaseOrderItemPreview: React.FC<PurchaseOrderItemPreviewProps> = ({
    purchaseOrderItem,
    onClick,
}) => {
    const theme = useTheme();


    const getDaysUntilETA = (eta: Date) => {
        return differenceInDays(eta, new Date());
    }

    return (
        <Stack
            onClick={onClick}
            sx={{
                flexDirection: 'column',
                alignItems: 'flex-start',
                cursor: onClick ? 'pointer' : 'default',
                '&:hover': onClick ? {
                    backgroundColor: 'action.hover',
                    borderRadius: 1,
                } : {},
            }}

            direction="row" width="100%" justifyContent="space-between" alignItems="center" spacing={2}>

            <Stack direction="row" width="100%" justifyContent="space-between" alignItems="center" spacing={2}>

                <Stack direction="row" alignItems="center" spacing={2}>
                    <Stack direction="column" spacing={0}>

                        {purchaseOrderItem.shipment ? (
                            <Stack direction="row" alignItems="center" spacing={2}>
                                <TransportMethodIcon size={48} transportMethod={purchaseOrderItem.shipment.transportMethod} />

                                <Stack direction="column" alignItems="flex-start" spacing={0}>
                                    <Typography variant="subtitle2" color="text.secondary">
                                        ETA:  {purchaseOrderItem.shipment.processedDate ? format(new Date(purchaseOrderItem.shipment.processedDate), 'EEE, MMM dd, yyyy') : 'N/A'}
                                    </Typography>
                                    <Typography variant="subtitle2" color="text.secondary">
                                        Arrives in  {getDaysUntilETA(purchaseOrderItem.shipment.processedDate)} days
                                    </Typography>
                                </Stack>
                            </Stack>
                        ) : (
                            <Stack direction="row" alignItems="center" spacing={2}>
                                <Box
                                    width={48}
                                    height={48}
                                    display="flex"
                                    sx={{
                                        border: `1px solid ${theme.palette.divider}`,
                                        borderRadius: 1,
                                        boxSizing: 'border-box',
                                    }}
                                >
                                </Box>


                                <Stack direction="column" alignItems="flex-start" spacing={0}>
                                    <Typography variant="subtitle2" color="text.secondary">
                                        ETA: {purchaseOrderItem.eta ? format(new Date(purchaseOrderItem.eta), 'EEE, MMM dd, yyyy') : 'N/A'}
                                    </Typography>
                                    <Typography variant="subtitle2" color="text.secondary">
                                        Arrives in  {purchaseOrderItem.eta ? getDaysUntilETA(purchaseOrderItem.eta) : 'N/A'} days
                                    </Typography>
                                </Stack>
                            </Stack>
                        )}


                    </Stack>
                </Stack>

                <Box sx={{ display: 'flex', alignItems: 'center', gap: 4 }}>
                    <Typography variant="body2" color="text.primary">
                        {purchaseOrderItem.quantity || 0} items
                    </Typography>

                </Box>

            </Stack>

        </Stack>
    );
};

export default PurchaseOrderItemPreview; 